import React, { useMemo } from 'react'
import { makeStyles, tokens } from '@fluentui/react-components'
import { HighlightedText } from '../../components/common/outputs/HighlightedText'
import { buildSnippet, textHead } from '../../helpers/highlightHelper'
import { searchableText } from '../../helpers/textHelper'

const useStyles = makeStyles({
   body: {
      lineHeight: tokens.lineHeightBase300,
      fontSize: tokens.fontSizeBase300,
      fontWeight: tokens.fontWeightRegular,
   },
})

type SearchHitTextCellProps = {
   html: string
   normalizedQuery: string
}

/**
 * A window around the match rather than the first 300 characters, since the whole text is searched
 * and a match can sit well past where the column used to cut off.
 */
export const SearchHitTextCell = ({ html, normalizedQuery }: SearchHitTextCellProps): JSX.Element => {
   const classes = useStyles()
   const source = useMemo(() => searchableText(html), [html])
   const segments = useMemo(() => buildSnippet(source, normalizedQuery), [source, normalizedQuery])

   return <span className={classes.body}>{segments ? <HighlightedText segments={segments} /> : textHead(source)}</span>
}
